import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ isHidden?: boolean }>`
    ${({ isHidden }) =>
        isHidden &&
        css`
            display: none;
        `};
`;
